import {useState, useEffect} from "react";
import SchoolSelect from "./SchoolSelect";
import RankComponent from "./RankComponent";
import {showPopUp} from "components/PopUp";

export default function Techlympic() {
  const [schoolData, setSchoolData] = useState(null);

  useEffect(() => {
    const data = localStorage.getItem("TechlympicSchoolData");

    if (data) {
      setSchoolData(JSON.parse(data));
    } else {
      // showPopUp(<SchoolSelect setSchoolData={setSchoolData} />, {
      //   defaultPadding: false,
      //   transparentBackground: true,
      //   clearOverHidden: true,
      // });
    }
  }, []);

  useEffect(() => {
    if (schoolData) {
      const data = JSON.stringify(schoolData);
      localStorage.setItem("TechlympicSchoolData", data);
    }
  }, [schoolData]);

  // return <>{schoolData !== null && <RankComponent schoolData={schoolData} setSchoolData={setSchoolData} />}</>;
  return <>{<RankComponent schoolData={schoolData} setSchoolData={setSchoolData} />}</>;
}
